/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import React from "react";
import { Link } from "react-router-dom";

const pressmark = css`
  background: #fff;
  background: #fff;
  margin: 10px;
  text-align: center;
  transition: all 0.4s;
  &:hover {
    cursor: pointer;
  }
  a {
    display: block;
  }
  .pressmark-link {
    color: #040404;
    &:hover {
      color: #f7c02d;
    }
  }
`;

const Pressmark = props => {
  return (
    <div css={pressmark}>
      <Link to={`/calculate/${props.id}`}>
        <span className="pressmark-link">{props.pressmark}</span>
      </Link>
    </div>
  );
};

export default Pressmark;
